var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 39,
    viewBox: "0 0 56 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_2741)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.19,
    height: 38.39,
    rx: 2.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_659_2741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 39
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55.19,
    height: 38.39,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_659_2741)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H55.19V38.39H0V0Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.046875,
    y: 7.99805,
    width: 55.19,
    height: 4.63879,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.046875,
    y: 16.3154,
    width: 55.19,
    height: 4.63879,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.193359,
    y: 24.3135,
    width: 55.19,
    height: 3.99896,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.193359,
    y: 32.3115,
    width: 55.19,
    height: 4.31887,
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H55.19V3.99896H0V0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H27.595V19.195H0V0Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19822 9.92129C6.19822 12.1227 7.3162 14.2044 9.59063 14.2044C13.0031 14.2044 13.667 13.5297 15.2593 12.5987C15.6357 13.383 14.3659 16.7391 9.54406 16.7391C5.68722 16.667 2.57031 13.7933 2.57031 9.92128C2.57031 5.47682 6.09484 3.07657 9.44727 3.10374C12.4069 3.10374 15.5459 4.66135 15.4497 6.64839C14.0552 5.38497 12.541 5.38497 10.0204 5.38497C7.49979 5.38497 6.19822 7.71963 6.19822 9.92129Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9709 11.6766L17.3721 13.8411L17.4503 11.2184L14.785 12.0979L16.5105 10.0187L13.7969 9.27727L16.5105 8.53582L14.785 6.45663L17.4503 7.33613L17.3721 4.71338L18.9709 6.87789L20.5698 4.71338L20.4916 7.33613L23.1568 6.45663L21.4314 8.53582L24.145 9.27727L21.4314 10.0187L23.1568 12.0979L20.4916 11.2184L20.5698 13.8411L18.9709 11.6766Z",
    fill: "#FECA00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_2741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.19,
    height: 38.39,
    rx: 2.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMy);
export default __webpack_public_path__ + "static/media/flagMY.3db07be3cbb0ea18703a580049877dd0.svg";
export { ForwardRef as ReactComponent };